import { SeqBufferRegistry } from './seqBuffer';

class CurrentAnswer {
  private running = false;

  private newChat = false;

  private placeholder: string | null = null;

  private messageIds = new Set<string>();

  private chunks = new SeqBufferRegistry();

  private droppedQuestions = 0;

  get isRunning(): boolean {
    return this.running;
  }

  get isNewChat(): boolean {
    return this.newChat;
  }

  get placeholderId(): string | null {
    return this.placeholder;
  }

  start({ placeholderId, isNewChat }: { placeholderId: string, isNewChat: boolean }): void {
    this.running = true;
    this.newChat = isNewChat;
    this.placeholder = placeholderId;
    this.messageIds.clear();
  }

  replacePlaceholder(messageId: string): void {
    if (!this.placeholder) {
      return;
    }

    this.placeholder = null;
    this.messageIds.add(messageId);
  }

  hasMessage(messageId: string): boolean {
    return this.messageIds.has(messageId);
  }

  addMessage(messageId: string): void {
    this.messageIds.add(messageId);
  }

  addChunk(messageId: string, seq: number, content: string): string {
    return this.chunks.add(messageId, seq, content);
  }

  getMessageIds(): Set<string> {
    const ids = new Set(this.messageIds);

    if (this.placeholder) {
      ids.add(this.placeholder);
    }

    return ids;
  }

  stop(): void {
    this.running = false;
    this.newChat = false;
    this.placeholder = null;
    this.messageIds.clear();
    this.chunks.clear();
  }

  dropQuestion(): void {
    if (this.placeholder) {
      this.droppedQuestions += 1;
    }
  }

  hasDroppedQuestions(): boolean {
    return this.droppedQuestions > 0;
  }

  skipDroppedReply(): boolean {
    if (this.droppedQuestions === 0) {
      return false;
    }

    this.droppedQuestions -= 1;

    return true;
  }
}

export default CurrentAnswer;
